module.exports = __webpack_public_path__ + "static/fc_home_center-9d6db464dcc7253f6aa1e7a303860912.jpg";